var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-328 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-341.308 202.79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(672.398 326.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.1,341.093a.521.521,0,0,1-.521-.521V330.186a2.938,2.938,0,0,0-2.935-2.935h-6.334a2.938,2.938,0,0,0-2.934,2.935v10.387a.521.521,0,1,1-1.041,0V330.186a3.98,3.98,0,0,1,3.976-3.976h6.334a3.981,3.981,0,0,1,3.976,3.976v10.387A.521.521,0,0,1,692.1,341.093Z",
    transform: "translate(-678.337 -326.21)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(671.308 340.746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.462,383.088H670.776a.524.524,0,0,1,0-1.041h15.685a.524.524,0,0,1,0,1.041Z",
    transform: "translate(-670.308 -382.047)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(677.034 341.316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.37,387.372h-1.121a2.117,2.117,0,0,1-2.1-2.127v-.486a.521.521,0,1,1,1.041,0v.486a1.075,1.075,0,0,0,1.062,1.085h1.121a1.075,1.075,0,0,0,1.062-1.085v-.486a.521.521,0,1,1,1.041,0v.486A2.117,2.117,0,0,1,699.37,387.372Z",
    transform: "translate(-696.146 -384.239)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.7fa2ef01712b983b2fd419b610969979.svg";
export { ForwardRef as ReactComponent };